const initiaPaypalOptions = {
    "client-id": "AdcByCW9RB2SbaP0szsJ800Q0vgmT29jLlRsKRl0YYHE2_H1Z8PujfFun1pbFyK0aN4pRwtmA2Qv7BZ7", //"AQtLGvphWDqgqlfa0G5N3CR1H1xLBUWUTtyVGKI3hYpe0T4GsvfDuNPEYNTkv4FybwwqqxiDOfYT_joj",
    "currency": "EUR",
    "locale": "en_US"
}
export default initiaPaypalOptions;